let globalTooltiplInstance = null, tooltipText = '***';

export const setTooltipInstance = (instance) => {
  globalTooltiplInstance = instance;
}

export const setTooltipTarget = (e = null, text) => {
  globalTooltiplInstance.show(e['srcElement'], text);
}

export const getTooltipText = () => {
  return tooltipText;
}
